import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectCreatorsState = (state) => state.addCreatorPage || initialState;

export const selectAddCreatorHistory = createSelector(
  [selectCreatorsState],
  (creatorsState) => creatorsState.addCreatorHistory
);

export const selectAddCreator = createSelector(
  [selectCreatorsState],
  (creatorsState) => creatorsState.addCreator
);
